import {useState} from 'react'
import SideBar from "../components/SideBar"
import {useDispatch} from "react-redux"
import { registerUser } from '../store/actions'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
export default function RegisterPage(){
    const dispatch= useDispatch()
    const navigate= useNavigate()
    const [registerInput, setRegister]= useState({
        username: "",
        email: "",
        password: "",
        role:"Admin",
        phoneNumber: "",
        address: ""
    })

    const inputRegister= (e)=>{
       const {name,value}= e.target
       const input={
        ...registerInput,
        [name]:value
       }
       setRegister(input)
    }

    const RegisterHandler= (e)=>{
        e.preventDefault();
       dispatch(registerUser(registerInput))
       .then((response)=>{
        return response.json()
     })
     .then((data)=>{
         if(data.message){
            Swal.fire({
                icon: 'error',
                title: data.message
            })
            navigate('/register')
         }else{
            Swal.fire({
                icon: 'success',
                title: 'Success add admin'
            })
            navigate('/')
         }
     })
     .catch((error)=>{
         console.log(error);
     })
    }

    return(
        <div>
             <SideBar/>
        <form onSubmit={RegisterHandler}>
    <div className="justify-center items-center flex flex-col" style={{height:"100vh"}}>
    <div className="text-center rounded-lg" style={{width: "400px", height: "500px"}}>
        <p className="font-bold" style={{fontSize: "15pt"}}>Sign Up New Account</p>
        <div className="pt-5">
        <label>Username</label><br/>
        <input value={registerInput.username} name="username" onChange={inputRegister}  type="text" style={{width: "300px", height:"35px"}} placeholder="Username" className="border-2 rounded-md pl-2"/>
        </div>
        <div className="pt-5">
        <label>Email Address</label><br/>
        <input value={registerInput.email} name="email" onChange={inputRegister}  type="text" style={{width: "300px", height:"35px"}} placeholder="Email Address" className="border-2 rounded-md pl-2"/>
        </div>
        <div className="pt-5">
         <label>Password</label><br/>
        <input value={registerInput.password} name="password" onChange={inputRegister} type="password" style={{width: "300px", height:"35px"}} placeholder="Password"  className="border-2 rounded-md pl-2"/>
        </div>
        <div className="pt-5">
        <label>Phone Number</label><br/>
        <input value={registerInput.phoneNumber} name="phoneNumber" onChange={inputRegister}  type="text" style={{width: "300px", height:"35px"}} placeholder="Phone Number" className="border-2 rounded-md pl-2"/>
        </div>
        <div className="pt-5">
        <label>Address</label><br/>
        <input value={registerInput.address} name="address" onChange={inputRegister}  type="text" style={{width: "300px", height:"35px"}} placeholder="Address" className="border-2 rounded-md pl-2"/>
        </div>
        <div className="pt-5 pb-10">
        <button className="bg-purple-400 h-8 rounded-lg hover:bg-purple-300"  style={{width: "300px", height:"35px"}}>Sign Up</button>
        </div>
    </div>
    </div>
    </form>
    </div>
    )
}